import { getTranslation } from "../../lib/translations";
import { showToast } from "../toasts";

/**
 * Renew the current user session
 */
export async function renewSession() {
    return await fetch("/session/renew");
}

/**
 * End the current user session
 */
export async function end() {
    return await fetch("/session/logout");
}

/**
 * Get the session options from the app configuration
 */
export async function getOptions() {
    return (await fetch("/session/options").then((r) =>
        r.json()
    )) as ISessionOptions;
}

/**
 *
 * @param timeUntilWarning The time until the warning should be shown in milliseconds
 */
export async function registerTimeoutWarning(timeUntilWarning: number) {
    const toastTitle = (await getTranslation("SessionTimeoutTitle"));
    const toastBody = (await getTranslation("SessionTimeoutBody"));

    return new Promise<void>((res, rej) => {
        setTimeout(() => {
            showToast({
                body: toastBody,
                level: "warning",
                title: toastTitle,
            });
            res();
        }, timeUntilWarning);
    });
}

/**
 *
 * @param timeUntilSessionTimeout The time until the sesion should time out in milliseconds
 */
export async function registerTimeout(timeUntilSessionTimeout: number) {
    return new Promise<void>((res, rej) => {
        setTimeout(() => {
            end().then(() => (window.location.href = "/Error"));
            res();
        }, timeUntilSessionTimeout);
    });
}

interface ISessionOptions {
    /** The number of minutes until session timeout. */
    timeoutDuration: number;
    /** The number of minutes until the session warning is given. */
    timeBeforeWarning: number;
}
